/* eslint-disable */
import { ORDER_CATEGORIES } from '@/config/createOrdersStepConfig';
import { CheckCircle2 } from 'lucide-react';

const SelectOrderCategory = (props) => {
	const {
		selectedCategories = [],
		onToggle,
		internalPOTypes,
		flatten = false,
		categories = [],
	} = props;

	const visibleCategories = ORDER_CATEGORIES
		.filter((c) => categories.includes(c.key))
		.filter((c) => !c.orderType
			|| !internalPOTypes?.length
			|| internalPOTypes.some(
				(t) => String(t).toUpperCase() === String(c.orderType).toUpperCase()
			));

	return (
		<div className='flex flex-col h-full min-h-0'>
			<style>
				{`@keyframes catIconSwing {
					0% { transform: rotate(0deg); }
					5% { transform: rotate(-10deg); }
					10% { transform: rotate(8deg); }
					15% { transform: rotate(-6deg); }
					20% { transform: rotate(4deg); }
					25% { transform: rotate(-2deg); }
					30%, 100% { transform: rotate(0deg); }
				}`}
			</style>
			{/* Hero header */}
			<div className='shrink-0 border-b border-gray-100 bg-gradient-to-b from-amber-50/70 via-white to-white px-6 py-4 text-center'>
				<h2 className='m-0 text-[22px] font-bold text-gray-900'>
					What would you like to create?
				</h2>
				<p className='mx-auto mt-1 max-w-[560px] text-[13px] text-gray-500'>
					{flatten
						? `Pick one or more order categories. They are combined into a
							single flow — each category adds its own steps to the same
							sequence.`
						: `Pick one or more order categories. Each selected category
							becomes a step in your sequence — basic details first, then
							the products table.`}
				</p>
			</div>
			{/* Category cards + sequence */}
			<div className='flex-1 overflow-auto px-6 py-6'>
				<div className='mx-auto flex max-w-[1040px] flex-col gap-5'>
					<div className='grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3'>
						{visibleCategories.map((category) => {
							const Icon = category.icon;
							const orderIndex = selectedCategories.indexOf(category.key);
							const isSelected = orderIndex !== -1;
							return (
								<button
									key={category.key}
									type='button'
									onClick={() => onToggle?.(category.key)}
									className={`relative flex flex-col items-start gap-3 rounded-xl border p-5 text-left transition-all ${
										isSelected
											? 'border-amber-400 bg-amber-50/50 shadow-sm'
											: 'border-gray-200 bg-white hover:border-amber-200 hover:shadow-sm'
									}`}
								>
									{isSelected && (
										<CheckCircle2 className='absolute top-3 right-3 size-5 fill-amber-400 text-white' />
									)}
									<div className='relative'>
										<div className={`flex size-12 items-center justify-center rounded-xl ${
											isSelected ? 'bg-amber-400' : 'bg-gray-100'
										}`}
										>
											<Icon
												className={`size-6 ${isSelected ? 'text-gray-900' : 'text-gray-500'}`}
												style={isSelected ? undefined : {
													animation: 'catIconSwing 6s ease-in-out infinite',
													transformOrigin: 'top center',
												}}
											/>
										</div>
										{isSelected && (
											<span className='absolute -top-1.5 -left-1.5 flex size-5 items-center justify-center rounded-full bg-gray-900 text-[11px] font-bold text-amber-400'>
												{orderIndex + 1}
											</span>
										)}
									</div>
									<p className='text-[15px] font-semibold text-gray-900'>
										{category.label}
									</p>
									<p className='text-[12px] leading-snug text-gray-500'>
										{category.description}
									</p>
								</button>
							);
						})}
					</div>
				</div>
			</div>
		</div>
	);
};

export default SelectOrderCategory;
